import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolumeMuteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volume_mute"}/>
}
